import { createApp } from 'vue';
import App from './../../App.vue';
import router from './../../router';
import store from './../../store'; // Or Pinia if you're using it
import { VueFire, VueFireAuth } from 'vuefire';
import { firebaseApp, auth, firestore } from './../../firebase'; // Import Firebase services
import axios from 'axios'; // Import Axios
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import { VueReCaptcha } from "vue-recaptcha-v3";

const app = createApp(App);

const sweetalertOptions = {
  confirmButtonColor: "#2881f4", // Green confirm button
  cancelButtonColor: "#d33", // Red cancel button (if used)
};


app.config.globalProperties.$axios = axios;
app.use(VueSweetalert2, sweetalertOptions)
// app.use(VueReCaptcha, {
//   siteKey: "6Le3BcoqAAAAANqvFl80-tHlaltwqwpdbtwydTee", // Replace with your Google reCAPTCHA site key v3
// });

// app.use(VueReCaptcha, {
//   siteKey: "6LcPCcoqAAAAAAGqh6P5wzdlfLNOVJyGltzB5jWi", // Replace with your Google reCAPTCHA site key v3
// });

// Use VueFire with Firebase app and authentication module
app.use(router);
app.use(store); // Or app.use(pinia) if you're using Pinia
app.use(VueFire, {
  firebaseApp, // Pass the initialized firebaseApp here
  modules: [VueFireAuth], // Add any other VueFire modules if needed
});

app.mount('#app');
